import { Link } from 'react-router-dom';
import { getFeaturedArticles } from '@/mocks/articles';

export default function HotRecommend() {
  const featured = getFeaturedArticles();

  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
            <i className="ri-fire-fill"></i> 热门推荐
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            热门推荐磁力网站
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            综合评分最高的磁力搜索网站，经过严格筛选和用户验证，资源丰富、速度稳定。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 max-w-6xl mx-auto">
          {featured.map(site => (
            <Link
              key={site.id}
              to={`/article/${site.slug}`}
              className="group bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-300 transition-all duration-300 overflow-hidden cursor-pointer"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={site.imageUrl}
                  alt={site.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3 flex items-center gap-2">
                  <span className="px-2 py-1 rounded-md bg-accent-500 text-background-50 text-xs font-medium">
                    热门
                  </span>
                  {site.isNew && (
                    <span className="px-2 py-1 rounded-md bg-primary-500 text-background-50 text-xs font-medium">
                      新收录
                    </span>
                  )}
                </div>
                <div className="absolute top-3 right-3 flex items-center gap-1 px-2 py-1 rounded-md bg-background-50/90 text-foreground-900 text-xs font-bold">
                  <i className="ri-star-fill text-amber-400 text-xs"></i>
                  {site.rating}
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading font-bold text-foreground-900 mb-2 text-base group-hover:text-primary-600 transition-colors">
                  {site.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                  {site.description}
                </p>
                <div className="flex flex-wrap gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-speed-up-fill text-primary-500"></i> {site.speed}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-shield-check-fill text-accent-500"></i> {site.stability}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-database-2-fill text-secondary-600"></i> {site.resources}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}